import React, { useState } from "react";
import blogs from "../../../data/blogs";
import BlogCard from "../BlogCard/BlogCard";
import FeaturedBlog from "../FeaturedBlog/FeaturedBlog";
import FilterTags from "../FilterTags/FilterTags";
import "./BlogPage.css";

const BlogPage = () => {
  const featured = blogs.find((blog) => blog.featured);
  const [selectedCategory, setSelectedCategory] = useState("Hepsi");

  const filteredBlogs = blogs.filter(
    (blog) =>
      !blog.featured &&
      (selectedCategory === "Hepsi" || blog.category === selectedCategory)
  );


  return (
    <div className="blog-page">
      <section className="featured-section">
        <FeaturedBlog blog={featured} />
      </section>

      <div className="blog-header">
        <FilterTags
          categories={["Blog Yazıları", "Bültenler","Haberler"]}
          selected={selectedCategory}
          onSelect={setSelectedCategory}
        />
      </div>


      <div className="blog-grid">
        {filteredBlogs.map((blog) => (
          <BlogCard key={blog.id} blog={blog} />
        ))}
      </div>
    </div>
  );
};

export default BlogPage;
